// Чтение: разделы попадают в панель, только если их дверь — та, что открыта сейчас. Сверка
// именно при ЧТЕНИИ закрывает разом оба пути утечки: и эмит уходящего экрана, принятый ещё не
// снятым слушателем прошлой двери (слушатель снимается в пассивной фазе, а дверь меняется уже
// в рендере), и потерянный сброс состояния, если React перезапустил рендер (мутация ref в
// рендере перезапуск переживает, а render-phase setState — нет).
export function screenSectionsForDoor(held, doorId) {
    return held && doorId && held.doorId === doorId ? held.sections : null;
}
// Запись: дверь события сверяется с текущей В МОМЕНТ события (ref рендера), а не с замыканием
// эффекта, которое остаётся живым до пассивной фазы уже после смены двери.
export function acceptsDoorSections(currentDoorId, payloadProductId) {
    return typeof payloadProductId === "string" && !!currentDoorId && payloadProductId === currentDoorId;
}
